import { Injectable } from '@angular/core';

import { IndustryModel } from '~app/models/industry.model';
import { BaseCrudStore } from '~core/abstractions/base-crud.store';
import { StoreConfig } from '~core/models/store.config';

@Injectable({
    providedIn: 'root'
})
export class IndustriesStore extends BaseCrudStore<IndustryModel, IndustryModel> {
    constructor() {
        super(new StoreConfig({ baseController: 'industries' }));
    }
}
